document.addEventListener('DOMContentLoaded', function () {
    var colorSplide = new Splide('#color-slide', {
        type   : 'slide',
        gap    : '6px',
        autoWidth: true,
        autoHeight: true, 
        omitEnd: true,
        arrows: true,
        width: '95%',
        trimSpace: true,
        pagination: false,
        perMove: 7,
    }); 


    colorSplide.mount();

    var colorLinks = document.querySelectorAll('.color_link');
    var colorNameElement = document.getElementById('color-name');
    var activeColorElement = document.querySelector('.active_color');
    var activeColorName = activeColorElement ? activeColorElement.getAttribute('data-color-name') : '';

    // Set the initial color name to the active color name
    if (activeColorName) {
        colorNameElement.textContent = activeColorName;
    }

    colorLinks.forEach(function(link) {
        link.addEventListener('mouseover', function() {
            var colorName = link.getAttribute('data-color-name');
            colorNameElement.textContent = colorName;
        });

        link.addEventListener('mouseout', function() {
            colorNameElement.textContent = activeColorName;
        });
    });
});